import { Description } from './Labels';
import { Question } from './Question';
import { QuestionGroup } from 'types';

type QuestionsProps = {
	group?: QuestionGroup;
};

export function Questions({ group }: QuestionsProps) {
	return group ? (
		<>
			<Description {...group} />
			{group.questions.map(q => (
				<Question {...q} key={q.id} testId={group.testId} />
			))}
		</>
	) : null;
}
